import axiosRequest from "@/utils/axios-utils";
import { fetchHandshake } from "../auth/login";
const registerApiBack = async (registerData, headers) => {
  try {
    console.log({headers});
    
    const response = await axiosRequest.post(
      "/customer/v2/register",
      registerData,
      {
        headers,
      }
    );
    return response?.data;
  } catch (error) {
    throw {
      response: {
        status: error?.status || 500,
        data: {
          message:
            error?.err?.response?.data?.error?.message ||
            error?.err?.response?.data?.message,
        },
      },
    };
  }
};

export default registerApiBack;

export const sendOtpByPhoneAndEmail = async (token, email, mobilenumber, recaptchaToken) => {
  const data = JSON.stringify({
    mobilenumber: "966".concat(mobilenumber?.slice(-9)),
    otptype: "register",
    email,
    resendotp: "",
    oldmobile: "",
  });
  const config = {
    method: "post",
    url: "/customer/v2/otpSend",
    headers: {
      Authorization: `Bearer ${token}`,
      woocommerce: `Bearer ${recaptchaToken}`,
      appname: "Bearer next",
    },
    data,
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    throw error;
  }
};

export const verifyOTPByPhone = async (
  token,
  mobilenumber,
  otpcode,
  locale,
  recaptchaToken
) => {
  const handshake = await fetchHandshake({ token, locale });

  const data = JSON.stringify({
    mobilenumber: "966".concat(mobilenumber?.slice(-9)),
    email: "",
    otpcode: otpcode,
    otptype: "register",
    oldmobile: "",
  });
  const config = {
    method: "post",
    url: "/customer/v2/otpVerfiy",
    headers: {
      Authorization: `Bearer ${handshake}`,
      woocommerce: `Bearer ${recaptchaToken}`,
      appname: "Bearer next",
    },
    data,
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return {
      err: error,
      data: null,
    };
  }
};
